/**
 * Deal Summary selector-delta telemetry bootstrap (Rally US2040919).
 *
 * Registers the Deal Summary selector manifest (`./registrations.ts`) with the
 * shared telemetry registry. Called exactly once from the dash bootstrap (see
 * `apps/accelerate/dash/src/dash.tsx`). Idempotent — the underlying registry
 * (`registerSelectorTelemetry`) dedupes by key, so repeated calls (test
 * isolation, hot reload) do not double-register.
 */
import { registerSelectorTelemetry } from '@makemydeal/dr-shared-store/telemetry/selectorRegistry';
import type { StateTree } from '@makemydeal/dr-dash-types';

import { dealSummarySelectorTelemetry } from './registrations';

// Re-export the manifest so tests and downstream tooling have a single import
// surface for the registered catalogue.
export { dealSummarySelectorTelemetry } from './registrations';

/**
 * Register every Deal Summary selector with the shared telemetry registry.
 * Called once from the dash bootstrap. Idempotent by key.
 */
export const registerDealSummarySelectorTelemetry = (): void => registerSelectorTelemetry<StateTree>(dealSummarySelectorTelemetry);
